import { fn, get } from '@ember/helper';
import { on } from '@ember/modifier';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { formatSubtypeLabelForCompsetPosPerStrategy } from 'lumen/utils/strategy/format-helper-utils';

interface HotelStrategyCompsetPositionSignature {
  Args: {
    subtypesWithStrategy: unknown;
    switchToDetail: unknown;
  };
}

export default class HotelStrategyCompsetPosition extends Component<HotelStrategyCompsetPositionSignature> {
  @service declare intl: Services['intl'];
  @service declare rsSelections: Services['rs-selections'];
  @service declare store: Services['store'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get compsetSize() {
    return this.rsSelections?.compsetSize;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get subtypeCompsetLabels() {
    const customCompsetPositionBlockLabels = {};

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.args.subtypesWithStrategy.forEach((subtype) => {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      customCompsetPositionBlockLabels[subtype.id] =
        formatSubtypeLabelForCompsetPosPerStrategy(
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          subtype,
          this.intl,
          // @ts-expect-error: Incorrect type
          this.store,
        );
    });

    return customCompsetPositionBlockLabels;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get usualPricePoint() {
    return this.rsSelections?.usualPricePoint;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get usualPricePointPosition() {
    if (this.usualPricePoint === 0) {
      return this.intl.t('general.missing');
    }

    return `${this.usualPricePoint}/${this.compsetSize}`;
  }

  <template>
    <div>
      <button
        class="button--unstyled position-button position-button--primary"
        type="button"
        {{! @glint-expect-error: Incorrect type }}
        {{on "click" (fn @switchToDetail null)}}
      >
        <p class="text-300--regular">{{t
            "strategy.avg_best_available_rate"
          }}</p>
        <div class="position-badge position-badge--primary">{{t
            "strategy.metric_block.your_position"
            position=this.usualPricePointPosition
          }}
        </div>
      </button>
      {{! @glint-expect-error: Incorrect type }}
      {{#each @subtypesWithStrategy as |subtype|}}
        {{#if subtype.hasNeutralPosition}}
          <button
            class="position-button"
            type="button"
            {{! @glint-expect-error: Incorrect type }}
            {{on "click" (fn @switchToDetail subtype)}}
          >
            {{! @glint-expect-error: Incorrect type }}
            <p class="text-300--regular truncate">{{get
                this.subtypeCompsetLabels
                subtype.id
              }}</p>
            <div class="position-badge position-badge--neutral">
              {{t
                "strategy.metric_block.your_position"
                position=subtype.formattedSubtypePosition
              }}
            </div>
          </button>
        {{else}}
          <button
            class="button--unstyled position-button position-button--warning"
            type="button"
            {{! @glint-expect-error: Incorrect type }}
            {{on "click" (fn @switchToDetail subtype)}}
          >
            {{! @glint-expect-error: Incorrect type }}
            <p class="text-300--regular truncate">{{get
                this.subtypeCompsetLabels
                subtype.id
              }}</p>
            <div
              class="position-badge position-badge--warning text-200--medium"
            >{{t
                "strategy.metric_block.your_position"
                position=subtype.formattedSubtypePosition
              }}
              <PrismIcon
                @name={{if
                  subtype.isHigherThanUsualPricePoint
                  "arrow-down"
                  "arrow-up"
                }}
                @size="small"
                class="ml-100"
              />
            </div>
          </button>
        {{/if}}
      {{/each}}
    </div>
  </template>
}
